import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams, useSearch } from "@tanstack/react-router";
import { recordQueryOptions } from "@/services/record/record.options";
import { OrgRecordTypeFullIndexTabContent } from "./OrgRecordTypeFullPage";

const FULL_INDEX =
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/recordTypes/$recordTypeId/full/" as const;

const FULL_PARENT =
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/recordTypes/$recordTypeId/full" as const;

export const Route = createFileRoute(FULL_INDEX)({
	component: OrgRecordTypeFullIndexRoute,
});

function OrgRecordTypeFullIndexRoute() {
	const params = useParams({ from: FULL_PARENT });
	const search = useSearch({ from: FULL_PARENT });

	const detailQuery = useQuery(
		recordQueryOptions.recordTypeDetail(params.recordTypeId, {
			organizationId: params.orgId,
		}),
	);

	const recordType = detailQuery.data ?? null;

	if (!recordType) {
		return null;
	}

	return (
		<OrgRecordTypeFullIndexTabContent
			tab={search.tab}
			recordType={recordType}
			orgId={params.orgId}
		/>
	);
}
